/**
 * 部署情報取得API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 会社情報
 */
export interface Sgkd991aReqCompanyInfo {

    /**
     * 会社グループコード：半角英数混在
     */
    companyGroupCode?: string;

     /**
     * 会社コード：半角英数混在
     */
     companyCode?: string;
}

